import React from 'react';
import styles from './ORSMActivationFailed.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';

interface Props {
	onClose: () => void;
}

const ORSMActivationFailed: React.FC<Props> = ({ onClose }) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.circle1}>
				<div className={styles.circle2}>
					<img
						src='/dist/icons/subscription/circle-exclamation-solid-full.svg'
						alt='red alert'
					/>
				</div>
			</div>
			<Text
				tx='component.ORSMActivationFailed.message'
				className={styles.title}
			/>
			<Text tx='component.ORSMActivationFailed.text' />
			<Button
				theme={Theme.BLUE}
				title='component.ORSMActivationFailed.close'
				className={styles.button}
				onClick={onClose}
			/>
		</div>
	);
};

export default ORSMActivationFailed;
